export default "__VITE_PUBLIC_ASSET__04964085__"